import API from "../../../../../global/api";


export const requestAddArea = () => {
  return {
    type: "REQUEST_ADD_AREA",
  };
};
export const successAddArea = (data) => {
  return {
    type: "SUCCESS_ADD_AREA",
    payload: data,
  };
};
export const errorAddArea = () => {
  return {
    type: "ERROR_ADD_AREA",
  };
};
export const AddAreaApi = (data, showSuccess, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestAddArea());
    API.post(`/area/add-area`, data)
      .then((res) => {
        dispatch(successAddArea(data));
        showSuccess(res.data.message);
      }).catch((error) => {
        dispatch(errorAddArea());
        showErrorAlert(error.response.data.message || "Something went wrong");
      });
  };
};


export const requestGetArea = () => {
  return {
    type: "REQUEST_GET_AREA",
  };
};
export const successGetArea = (data) => {
  return {
    type: "SUCCESS_GET_AREA",
    payload: data,
  };
};
export const errorGetAllArea = () => {
  return {
    type: "ERROR_GET_AREA",
  };
};
export const GetAreaApi = (data) => {
  return (dispatch) => {
    dispatch(requestGetArea());
    API.get(`/area/get-areas`)
      .then((res) => {
        let data1 = res.data;
        dispatch(successGetArea(data1));
      }).catch((error) => {
        dispatch(errorGetAllArea());
      });
  };
};


export const UpdateRequestArea = () => {
  return {
    type: "UPDATE_REQUEST_AREA",
  };
};
export const UpdateSuccessArea = (data) => {
  return {
    type: "UPDATE_SUCCESS_AREA",
    payload: data,
  };
};
export const UpdateErrorArea = () => {
  return {
    type: "UPDATE_ERROR_AREA",
  };
};
export const UpdateAreaApi = (newData, oldData) => {
  return (dispatch) => {
    dispatch(UpdateRequestArea());
    API.put(`/area/update-area/${oldData._id}`,
      {
        areaName: newData.areaName,
        areaDesc: newData.areaDesc,
        location: newData.location,
      },
      {}
    ).then((res) => {
      dispatch(UpdateSuccessArea([newData]));
    }).catch((error) => {
      dispatch(errorGetAllArea());
    });
  };
};


export const DeleteRequestArea = () => {
  return {
    type: "DELETE_REQUEST_AREA",
  };
};
export const DeleteSuccessArea = (id) => {
  return {
    type: "DELETE_SUCCESS_AREA",
    id: id,
  };
};
export const DeleteErrorArea = () => {
  return {
    type: "DELETE_ERROR_AREA",
  };
};
export const DeleteAreaApi = (id) => {
  return (dispatch) => {
    dispatch(DeleteRequestArea());
    API.delete(`/area/delete-area/${id}`)
      .then((res) => {
        dispatch(DeleteSuccessArea(id));
      }).catch((error) => {
        dispatch(errorGetAllArea());
      });
  };
};